/* ==========================================================================
   Monta Cometa · Bundle builder de landings
   Config esperada en window.MCLP (ver templates/page.lp-*.liquid)

   Modelo: el pack define CUÁNTOS accesorios trae y qué descuento aplica.
   Cuáles accesorios los elige siempre el cliente, en cualquier pack.
   ========================================================================== */
(function () {
  var C = window.MCLP;
  if (!C) return;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  var state = {
    base: 0,
    tier: typeof C.defaultTier === 'number' ? C.defaultTier : 1,
    chosen: []   /* accesorios elegidos, en el orden en que los fue marcando */
  };

  /* todos los precios de la config van en pesos, no en centavos */
  function money(n) {
    var s = n.toLocaleString('es-MX', {
      minimumFractionDigits: n % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    });
    return '$' + s;
  }

  function base() { return C.bases[state.base]; }
  function tier() { return C.tiers[state.tier]; }

  /* ---------- envío ----------
     Con `shippingCode` la landing regala el envío sin mínimo (el código se
     encadena al pasar al carrito). Sin él aplica el mínimo normal de la
     tienda, que vive en `freeShippingMin`. */
  function alwaysFreeShip() { return !!C.shippingCode; }
  function shipMin() { return C.freeShippingMin || 0; }

  /* ---------- cálculo ----------
     Para el pack seleccionado se usa lo que el cliente eligió.
     Para los demás se usa su selección sugerida, así las tarjetas
     siguen siendo comparables entre sí. */

  function addonsOf(t, isCurrent) {
    return (t.fixed || []).concat(isCurrent ? state.chosen : (t.defaults || []));
  }
  function qtyOf(t, isCurrent) { return 1 + addonsOf(t, isCurrent).length; }
  function grossOf(t, isCurrent) {
    var sum = base().price;
    addonsOf(t, isCurrent).forEach(function (k) { sum += C.addons[k].price; });
    return sum;
  }
  /* el descuento solo entra si el pedido alcanza el mínimo de artículos
     del código, igual que lo valida Shopify */
  function discountOn(t, isCurrent) {
    return !!t.pct && qtyOf(t, isCurrent) >= (t.minQty || 0);
  }
  function netOf(t, isCurrent) {
    var g = grossOf(t, isCurrent);
    return discountOn(t, isCurrent) ? Math.round(g * (100 - t.pct)) / 100 : g;
  }

  /* ---------- render ---------- */

  function renderGallery() {
    var b = base();
    var main = $('#mc-gal-main');
    var thumbs = $('#mc-gal-thumbs');
    if (!main || C.fixedGallery) return;
    main.src = b.imgs[0];
    main.alt = b.name;
    if (thumbs) {
      thumbs.innerHTML = b.imgs.map(function (src, i) {
        return '<button type="button" data-i="' + i + '" aria-current="' + (i === 0) + '">' +
               '<img src="' + src + '" alt="" loading="lazy"></button>';
      }).join('');
    }
    var tag = $('#mc-gal-tag');
    if (tag) tag.textContent = b.tag || b.name;
  }

  function renderPicker() {
    $$('.mc-pick').forEach(function (el, i) {
      el.setAttribute('aria-pressed', String(i === state.base));
    });
    var d = $('#mc-base-desc');
    if (d) d.textContent = base().desc || '';

    /* social proof: solo se muestra en los productos que sí tienen reseñas */
    var line = $('#mc-rating');
    if (line) {
      var b = base();
      if (b.rating && b.raters) {
        line.innerHTML = '<span class="mc-rating__s">★★★★★</span> <b>' + b.rating +
          '</b> · ' + b.raters + ' reseñas verificadas de este ' + (b.kind || 'pastel');
        line.hidden = false;
      } else {
        line.hidden = true;
      }
    }
  }

  function renderTiers() {
    C.tiers.forEach(function (t, i) {
      var el = $('#mc-tier-' + i);
      if (!el) return;
      var cur = i === state.tier;
      var g = grossOf(t, cur), n = netOf(t, cur);

      el.classList.toggle('mc-is-on', cur);
      el.querySelector('input').checked = cur;

      var pb = el.querySelector('.mc-tier__price b');
      var ps = el.querySelector('.mc-tier__price s');
      pb.textContent = money(n);
      if (n < g) { ps.textContent = money(g); ps.style.display = ''; }
      else { ps.style.display = 'none'; }

      var sub = el.querySelector('.mc-tier__sub');
      if (sub) {
        var bits = [];
        if (t.subtext) bits.push(t.subtext);
        if (n < g) bits.push('Ahorras ' + money(g - n));
        else if (t.pct) {
          var falta = (t.minQty || 0) - qtyOf(t, cur);
          bits.push('Te falta ' + falta + (falta === 1 ? ' vela' : ' velas') + ' para el ' + t.pct + '%');
        }
        sub.textContent = bits.join(' · ');
      }

      /* la promesa de envío depende de la landing: con shippingCode va gratis
         siempre, sin él aplica el mínimo normal de la tienda */
      var perk = el.querySelector('[data-perk-ship]');
      if (perk) {
        if (alwaysFreeShip()) {
          perk.textContent = '🚚 Envío gratis, sin mínimo de compra';
        } else if (shipMin()) {
          perk.textContent = n >= shipMin()
            ? '🚚 Pasa los ' + money(shipMin()) + ', o sea envío gratis'
            : '🚚 Te faltan ' + money(shipMin() - n) + ' para el envío gratis';
        }
      }
    });

    var t = tier(), g = grossOf(t, true), n = netOf(t, true);

    var save = $('#mc-save');
    if (save) {
      if (n < g) {
        save.classList.remove('mc-is-hidden');
        $('#mc-save-amt').textContent = money(g - n);
      } else {
        save.classList.add('mc-is-hidden');
      }
    }

    var pb = $('#mc-buy-price'), ps = $('#mc-buy-compare');
    if (pb) pb.textContent = money(n);
    if (ps) {
      if (n < g) { ps.textContent = money(g); ps.style.display = ''; }
      else { ps.style.display = 'none'; }
    }

    var sp = $('#mc-sticky-price'), sn = $('#mc-sticky-note');
    if (sp) sp.textContent = money(n);
    if (sn) sn.textContent = qtyOf(t, true) + ' artículos · ' + t.name;

    var ship = $('#mc-ship-note');
    if (ship) {
      if (alwaysFreeShip()) ship.textContent = 'El envío va gratis, sin mínimo.';
      else if (shipMin()) {
        ship.textContent = n >= shipMin()
          ? 'Este pedido ya lleva envío gratis.'
          : 'Envío gratis a partir de ' + money(shipMin()) + '.';
      } else {
        ship.textContent = 'El envío se calcula en el carrito.';
      }
    }
  }

  /* ---------- accesorios: siempre elegibles, en cualquier pack ---------- */

  function renderUpsells() {
    var wrap = $('#mc-ups');
    if (!wrap || !C.upsells) return;

    wrap.innerHTML = C.upsells.map(function (k) {
      var a = C.addons[k];
      var on = state.chosen.indexOf(k) !== -1;
      return '<button type="button" class="mc-up' + (on ? ' mc-is-on' : '') +
        '" data-k="' + k + '" aria-pressed="' + on + '">' +
        '<img src="' + a.img + '" alt="' + a.name + '" loading="lazy">' +
        '<span class="mc-up__n">' + a.name + '</span>' +
        '<span class="mc-up__p">' + (on ? 'Agregado' : '+ ' + money(a.price)) + '</span>' +
        '<span class="mc-up__b">' + (on ? '✓' : '+') + '</span>' +
        '</button>';
    }).join('');

    var t = tier(), have = state.chosen.length, want = t.pick || 0;

    var head = $('#mc-ups-head');
    if (head) head.textContent = want ? 'Elige tus ' + want + ' velas' : 'Agrégale un detalle';

    var note = $('#mc-ups-note');
    if (!note) return;
    var falta = want - have;
    if (falta > 0) {
      note.textContent = 'El ' + t.name + ' lleva ' + want + '. Llevas ' + have +
        ', elige ' + falta + ' más para que entre el ' + t.pct + '% de descuento.';
      note.classList.add('mc-ups__note--warn');
    } else {
      note.classList.remove('mc-ups__note--warn');
      if (want && have > want) {
        note.textContent = 'Llevas ' + have + ' accesorios, ' + (have - want) +
          ' más de los que trae el pack. Los extras también entran al ' + t.pct + '%.';
      } else if (want) {
        note.textContent = 'Cámbialos por los que quieras, el precio se ajusta solo.';
      } else {
        note.textContent = have
          ? 'Llevas ' + have + (have === 1 ? ' accesorio.' : ' accesorios.') + ' Quítalos o cámbialos cuando quieras.'
          : 'Opcional. Agrega los que quieras y el precio se ajusta solo.';
      }
    }
  }

  function renderAll() { renderGallery(); renderPicker(); renderTiers(); renderUpsells(); }

  /* ---------- urgencia discreta: fecha real más pronta de entrega ---------- */

  function renderLead() {
    var el = $('#mc-lead');
    if (!el || !C.leadDays) return;
    var DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
    var MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio',
                 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    var d = new Date();
    d.setDate(d.getDate() + C.leadDays);
    el.textContent = 'Se prepara bajo pedido con ' + C.leadDays +
      ' días de anticipación. Pidiendo hoy, la entrega más pronta sería a partir del ' +
      DIAS[d.getDay()] + ' ' + d.getDate() + ' de ' + MESES[d.getMonth()] +
      ', según los espacios que queden en el calendario.';
  }

  /* ---------- analítica ----------
     Las landings son plantillas `page`, así que ninguna app sabe que aquí se
     está viendo un producto. Mandamos ViewContent / view_item a mano, con el
     mismo formato que usa la página de producto de la tienda.
     Cada canal se espera por su cuenta: fbq y gtag los inyecta
     content_for_header y no siempre llegan al mismo tiempo. */

  var sentMeta = null, sentGa = null, viewTimer = null;

  function whenReady(check, run, tries) {
    if (check()) { run(); return; }
    if (tries > 0) setTimeout(function () { whenReady(check, run, tries - 1); }, 400);
  }

  function metaReady() {
    var ids = C.metaPixels || [];
    if (!window.fbq || !window.fbq.loaded || !window.fbq.instance) return false;
    var reg = window.fbq.instance.pixelsByID || {};
    return ids.every(function (id) { return reg[id]; });
  }

  function sendMeta() {
    var b = base();
    if (!b.pid || sentMeta === b.id) return;
    sentMeta = b.id;
    var data = {
      content_ids: [b.id],
      content_type: 'product',
      content_name: b.tname || b.name,
      currency: 'MXN',
      value: b.price
    };
    if (b.tcat) data.content_category = b.tcat;
    (C.metaPixels || []).forEach(function (id) {
      try { window.fbq('trackSingle', id, 'ViewContent', data); } catch (e) {}
    });
  }

  function sendGa() {
    var b = base();
    if (!b.pid || sentGa === b.id) return;
    sentGa = b.id;
    try {
      var payload = {
        send_to: C.ga4 || 'G-0711FLCB2D',
        currency: 'MXN',
        value: b.price,
        items: [{
          item_id: String(b.pid),
          item_name: (b.tname || b.name).split(' - ')[0],
          price: b.price,
          quantity: 1
        }]
      };
      window.gtag('event', 'view_item', payload);
      if (window.dataLayer) window.dataLayer.push({ event: 'view_item', ecommerce: payload });
    } catch (e) {}
  }

  function trackView() {
    whenReady(metaReady, sendMeta, 45);
    whenReady(function () { return typeof window.gtag === 'function'; }, sendGa, 45);
  }

  /* al cambiar de producto esperamos un momento, para no mandar un evento
     por cada clic mientras el cliente pasea por el selector */
  function queueView() {
    clearTimeout(viewTimer);
    viewTimer = setTimeout(trackView, 700);
  }

  /* ---------- eventos ---------- */

  $$('.mc-pick').forEach(function (el, i) {
    el.addEventListener('click', function () { state.base = i; renderAll(); queueView(); });
  });

  C.tiers.forEach(function (t, i) {
    var el = document.getElementById('mc-tier-' + i);
    if (!el) return;
    el.addEventListener('click', function () {
      if (state.tier === i) return;
      state.tier = i;
      /* arranca con la selección sugerida del pack; el cliente la cambia a gusto */
      state.chosen = (C.tiers[i].defaults || []).slice();
      renderTiers();
      renderUpsells();
    });
  });

  var ups = $('#mc-ups');
  if (ups) {
    ups.addEventListener('click', function (e) {
      var b = e.target.closest('.mc-up');
      if (!b) return;
      var k = b.dataset.k, i = state.chosen.indexOf(k);
      if (i === -1) state.chosen.push(k); else state.chosen.splice(i, 1);
      renderUpsells();
      renderTiers();
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('#mc-gal-thumbs button');
    if (!b) return;
    var i = +b.dataset.i;
    $('#mc-gal-main').src = (C.fixedGallery ? C.gallery : base().imgs)[i];
    $$('#mc-gal-thumbs button').forEach(function (x) { x.setAttribute('aria-current', String(x === b)); });
  });

  /* ---------- carrito desplegable ---------- */

  var drawer = $('#mc-drawer');
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('mc-is-on'); });
    document.body.classList.add('mc-locked');
    var go = $('#mc-dr-go');
    if (go) go.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('mc-is-on');
    document.body.classList.remove('mc-locked');
    setTimeout(function () { drawer.hidden = true; }, 280);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  var lastCart = null;

  /* dentro del panel el descuento se juzga con el carrito real,
     porque ahí se pueden sumar más artículos */
  function cartDiscountOn(t) {
    return !!t.pct && lastCart && lastCart.item_count >= (t.minQty || 0);
  }

  /* recomendaciones para redondear el pedido */
  function renderSuggest(cart, sub, tot, t) {
    var wrap = $('#mc-dr-sug');
    if (!wrap || !C.suggest) return;

    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.variant_id || it.id] = true; });
    var pct = cartDiscountOn(t) ? t.pct : 0;

    var min = shipMin(), falta = alwaysFreeShip() ? 0 : min - tot;

    var list = C.suggest.map(function (k) { return C.addons[k]; })
      .filter(function (a) { return a && a.img && !inCart[a.id]; })
      .map(function (a) {
        var nt = Math.round((sub + a.price) * (100 - pct)) / 100;
        return { a: a, closes: falta > 0 && nt >= min };
      })
      /* si le falta poco para el envío gratis, primero las que lo cierran */
      .sort(function (x, y) {
        if (x.closes !== y.closes) return x.closes ? -1 : 1;
        return x.closes ? x.a.price - y.a.price : 0;
      })
      .slice(0, 2);

    if (!list.length) { wrap.hidden = true; return; }

    wrap.hidden = false;
    $('#mc-dr-sug-t').innerHTML = list[0].closes
      ? 'Te faltan <b>' + money(falta) + '</b>. Con esto el envío te sale gratis:'
      : (pct
          ? 'Súmale algo antes de cerrar. Todo entra al <b>' + pct + '%</b> del pack:'
          : 'Lo que más se lleva junto con esto:');

    $('#mc-dr-sug-l').innerHTML = list.map(function (o) {
      var a = o.a, neto = Math.round(a.price * (100 - pct)) / 100;
      var nota = o.closes ? 'Llegas al envío gratis'
               : (pct ? 'Te queda en ' + money(neto) : '');
      return '<button type="button" class="mc-sug" data-add="' + a.id + '">' +
        '<img src="' + a.img + '" alt="" loading="lazy">' +
        '<span class="mc-sug__t"><b>' + a.name + '</b>' +
        (nota ? '<em>' + nota + '</em>' : '') +
        '</span>' +
        '<span class="mc-sug__p">+ ' + money(a.price) + '</span>' +
        '<span class="mc-sug__b">+</span>' +
        '</button>';
    }).join('');
  }

  function renderDrawer(cart) {
    lastCart = cart;
    var t = tier();
    var sub = cart.original_total_price / 100;
    var off = cartDiscountOn(t) ? Math.round(sub * t.pct) / 100 : 0;
    var tot = sub - off;

    var pack = t.pct
      ? '<div class="mc-dr__pack">🎁 <span>Estás llevando el <b>' + t.name + '</b></span></div>'
      : '';

    $('#mc-dr-items').innerHTML = pack + cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
      return '<div class="mc-dr__i">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span class="mc-dr__ph"></span>') +
        '<div class="mc-dr__t"><b>' + it.product_title + '</b>' +
        (it.variant_title && it.variant_title !== 'Default Title'
          ? '<span>' + it.variant_title + '</span>' : '') +
        '</div>' +
        '<div class="mc-dr__p">' + money(it.original_line_price / 100) + '</div>' +
        '</div>';
    }).join('');

    $('#mc-dr-count').textContent = cart.item_count + (cart.item_count === 1 ? ' artículo' : ' artículos');
    $('#mc-dr-sub').textContent = money(sub);
    $('#mc-dr-tot').textContent = money(tot);

    var row = $('#mc-dr-offrow');
    if (off > 0) {
      row.hidden = false;
      $('#mc-dr-code').textContent = t.code;
      $('#mc-dr-off').textContent = '– ' + money(off);
    } else {
      row.hidden = true;
    }

    var ship = $('#mc-dr-ship');
    var bar = $('#mc-dr-bar-fill'), barT = $('#mc-dr-bar-t');
    var wrap = bar && bar.closest('.mc-dr__bar');
    var min = shipMin();

    if (alwaysFreeShip()) {
      ship.textContent = 'En el siguiente paso eliges día y horario de entrega.';
      ship.className = 'mc-dr__ship';
      if (bar) {
        bar.style.width = '100%';
        barT.innerHTML = '🚚 <b>Envío gratis incluido</b>, sin mínimo de compra';
        wrap.classList.add('mc-dr__bar--ok');
      }
    } else if (tot >= min && min) {
      ship.textContent = 'El envío de este pedido va por nuestra cuenta.';
      ship.className = 'mc-dr__ship mc-dr__ship--ok';
      if (bar) {
        bar.style.width = '100%';
        barT.innerHTML = '🚚 <b>Ya tienes envío gratis</b> en este pedido';
        wrap.classList.add('mc-dr__bar--ok');
      }
    } else {
      ship.textContent = 'El costo de envío se calcula en el siguiente paso.';
      ship.className = 'mc-dr__ship';
      if (bar) {
        bar.style.width = Math.max(4, Math.round(tot / min * 100)) + '%';
        barT.innerHTML = 'Te faltan <b>' + money(min - tot) + '</b> para el envío gratis';
        wrap.classList.remove('mc-dr__bar--ok');
      }
    }

    renderSuggest(cart, sub, tot, t);
  }

  /* agregar una sugerencia sin salir del panel */
  function addSuggestion(btn, id) {
    btn.disabled = true;
    btn.classList.add('mc-sug--busy');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] })
    })
      .then(function (r) {
        if (r.ok) return r.json();
        return r.json().then(function (j) { throw new Error(j.description || 'Error'); });
      })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) { renderDrawer(cart); })
      .catch(function (err) {
        btn.disabled = false;
        btn.classList.remove('mc-sug--busy');
        alert('No pudimos agregarlo: ' + err.message);
      });
  }

  /* Shopify aplica un codigo por URL, asi que los encadenamos:
     primero el pack y luego el envio gratis, y de ahi al carrito. */
  function discountUrl(codes, dest) {
    if (!codes.length) return dest;
    return '/discount/' + codes[0] + '?redirect=' +
      encodeURIComponent(discountUrl(codes.slice(1), dest));
  }

  function goToCart() {
    var t = tier();
    var ok = lastCart ? cartDiscountOn(t) : discountOn(t, true);
    var codes = [];
    if (t.code && ok) codes.push(t.code);
    if (C.shippingCode) codes.push(C.shippingCode);
    window.location.href = discountUrl(codes, '/cart');
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]')) { closeDrawer(); return; }
      var sug = e.target.closest('[data-add]');
      if (sug && !sug.disabled) addSuggestion(sug, sug.dataset.add);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) closeDrawer();
    });
    var go = $('#mc-dr-go');
    if (go) go.addEventListener('click', goToCart);
  }

  /* ---------- agregar al carrito ---------- */

  function items() {
    var out = [{ id: base().id, quantity: 1 }];
    addonsOf(tier(), true).forEach(function (k) {
      out.push({ id: C.addons[k].id, quantity: 1 });
    });
    return out;
  }

  function add(btn) {
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Armando tu pedido…';

    fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items() })
        });
      })
      .then(function (r) {
        if (r.ok) return r.json();
        return r.json().then(function (j) { throw new Error(j.description || j.message || 'Error'); });
      })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        btn.disabled = false;
        btn.textContent = label;
        if (drawer) { renderDrawer(cart); openDrawer(); }
        else goToCart();
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = label;
        alert('No pudimos armar tu pedido: ' + err.message + '\n\nEscríbenos por WhatsApp y lo resolvemos.');
      });
  }

  $$('[data-atc]').forEach(function (b) {
    b.addEventListener('click', function () { add(b); });
  });

  /* ---------- barra sticky ---------- */
  var sticky = $('#mc-sticky'), anchor = $('#mc-buy-anchor');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    document.body.classList.add('mc-has-sticky');
    new IntersectionObserver(function (es) {
      sticky.classList.toggle('mc-is-on', !es[0].isIntersecting);
    }, { rootMargin: '0px 0px -60% 0px' }).observe(anchor);
  }

  /* selección inicial = la sugerida del pack por defecto */
  state.chosen = (tier().defaults || []).slice();
  renderAll();
  renderLead();

  trackView();
})();
